<template>
  <path
    d="M1.718 13.5c-.397 0-.718-.298-.718-.665v-2.67c0-.367.321-.665.718-.665h12.564c.397 0 .718.298.718.665v2.67c0 .367-.321.665-.718.665H1.718zm.526-7C1.557 6.5 1 6.202 1 5.835v-2.67c0-.367.557-.665 1.244-.665h11.512c.687 0 1.244.298 1.244.665v2.67c0 .367-.557.665-1.244.665H2.244z"
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd" />
</template>
